/**
 * Generated from RestStopFreePlayCompletePopupLayout.fla
 */
export function RestStopFreePlayCompletePopupLayout(this: IRestStopFreePlayCompletePopupLayout) {
	const bg = this.bg;
	RestStopFreePlayCompletePopupLayout_bg.call(this.bg);
	bg.x = 515;
	bg.y = 397.5;
	bg.width = 966.94;
	bg.height = 712.06;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	RestStopFreePlayCompletePopupLayout_homeButton.call(this.homeButton);
	homeButton.x = 9;
	homeButton.y = 72.8;
	homeButton.width = 85.50;
	homeButton.height = 90.90;
	if (homeButton.onLayout) homeButton.onLayout();
	const buttonFive = this.buttonFive;
	RestStopFreePlayCompletePopupLayout_buttonFive.call(this.buttonFive);
	buttonFive.x = 515.05;
	buttonFive.y = 234.15;
	buttonFive.width = 320.98;
	buttonFive.height = 145.48;
	if (buttonFive.onLayout) buttonFive.onLayout();
	const buttonSeven = this.buttonSeven;
	RestStopFreePlayCompletePopupLayout_buttonSeven.call(this.buttonSeven);
	buttonSeven.x = 515.05;
	buttonSeven.y = 408.95;
	buttonSeven.width = 320.98;
	buttonSeven.height = 145.48;
	if (buttonSeven.onLayout) buttonSeven.onLayout();
	const buttonNine = this.buttonNine;
	RestStopFreePlayCompletePopupLayout_buttonNine.call(this.buttonNine);
	buttonNine.x = 514.95;
	buttonNine.y = 584.4;
	buttonNine.width = 320.98;
	buttonNine.height = 145.48;
	if (buttonNine.onLayout) buttonNine.onLayout();
	return this;
}
function RestStopFreePlayCompletePopupLayout_bg(this: IRestStopFreePlayCompletePopupLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-modal.png", 0.500, 0.500);
	return this;
}
function RestStopFreePlayCompletePopupLayout_homeButton(this: IRestStopFreePlayCompletePopupLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-home-btn-large.png", 0.000, 0.000);
	return this;
}
function RestStopFreePlayCompletePopupLayout_buttonFive(this: IRestStopFreePlayCompletePopupLayout_buttonFive) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain5.png", 0.500, 0.500);
	return this;
}
function RestStopFreePlayCompletePopupLayout_buttonSeven(this: IRestStopFreePlayCompletePopupLayout_buttonSeven) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain7.png", 0.500, 0.500);
	return this;
}
function RestStopFreePlayCompletePopupLayout_buttonNine(this: IRestStopFreePlayCompletePopupLayout_buttonNine) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain9.png", 0.500, 0.500);
	return this;
}
interface IRestStopFreePlayCompletePopupLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IRestStopFreePlayCompletePopupLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IRestStopFreePlayCompletePopupLayoutSprite extends IRestStopFreePlayCompletePopupLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IRestStopFreePlayCompletePopupLayoutText extends IRestStopFreePlayCompletePopupLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IRestStopFreePlayCompletePopupLayoutPolygon extends Array<number> {
}
interface IRestStopFreePlayCompletePopupLayout {
	readonly bg: IRestStopFreePlayCompletePopupLayout_bg;
	readonly homeButton: IRestStopFreePlayCompletePopupLayout_homeButton;
	readonly buttonFive: IRestStopFreePlayCompletePopupLayout_buttonFive;
	readonly buttonSeven: IRestStopFreePlayCompletePopupLayout_buttonSeven;
	readonly buttonNine: IRestStopFreePlayCompletePopupLayout_buttonNine;
}
interface IRestStopFreePlayCompletePopupLayout_bg extends IRestStopFreePlayCompletePopupLayoutSprite {
}
interface IRestStopFreePlayCompletePopupLayout_homeButton extends IRestStopFreePlayCompletePopupLayoutSprite {
}
interface IRestStopFreePlayCompletePopupLayout_buttonFive extends IRestStopFreePlayCompletePopupLayoutSprite {
}
interface IRestStopFreePlayCompletePopupLayout_buttonSeven extends IRestStopFreePlayCompletePopupLayoutSprite {
}
interface IRestStopFreePlayCompletePopupLayout_buttonNine extends IRestStopFreePlayCompletePopupLayoutSprite {
}
